import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import { Api } from '$api';
import { mainActions } from '$store/main';
import { getDeviceId, isNotificationsSupported, statReachGoal } from '$utils';
import { PUBLIC_URL, VAPID_KEY } from '$shared/constants';
import { goTo } from '$navigation/helper';
import { RESOLVE } from '$shared/constants/pages';
import router from '$navigation/router';

export function initPush(dispatch) {
  if (!isNotificationsSupported()) {
    return;
  }

  try {
    if ('Notification' in window) {
      if (Notification.permission === 'granted') {
        subscribe(dispatch);
      } else {
        console.log('need permissions');
      }
    }
  } catch (e) {
    console.log(e);
  }
}

export function subscribe(dispatch) {
  dispatch(mainActions.setNotifyEnabled(true));

  const messaging = getMessaging();
  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload);
    navigator.serviceWorker.ready.then((registration) => {
      registration
        .showNotification(payload.notification?.title || 'New notification', {
          body: payload.notification?.body,
          icon: payload.notification?.image || PUBLIC_URL + '/logo192.png',
        })
        .catch((e) => {
          console.log('showNotification error', e);
        });
    });
  });

  getToken(messaging, {
    vapidKey: VAPID_KEY,
  })
    .then((token) => {
      statReachGoal('save_push_token');
      const device = getDeviceId();
      Api.post('/account/push_token', {
        device,
        token,
        platform: 'web',
      }).catch((err) => console.log('err', err));
    })
    .catch((err) => {
      console.log('subscribe err', err);
    });
}
